interface BreadCrumbsProps {
    breadcrumbItems: string[];
}

export const BreadCrumbs: React.FC<BreadCrumbsProps> = ({ breadcrumbItems }) => {
    return (
        <div style={{ display: 'flex' }}>
            {breadcrumbItems.map((item, index) => {
                const isLast = index === breadcrumbItems.length - 1;
                return (
                    <div key={index} style={{ fontSize: '12px' }} aria-current="page">
                        <span style={isLast ? { fontWeight: 'bold' } : {}}>{item}</span>
                        {!isLast && <span className="mx-1"> &gt; </span>}
                    </div>
                );
            })}
        </div>
    );
};